<template></template>

<script>
    import {createNamespacedHelpers} from 'vuex';
    const {mapMutations} = createNamespacedHelpers('Auth');

    export default {
        name: "Logout401",
        methods: {
            ...mapMutations(['toggleLogout']),
        },
        created() {
            localStorage.clear();
            this.toggleLogout();
            this.$router.push({name: 'Home'});
        }
    }
</script>